export default __webpack_public_path__ + "047baba4b06b867ece1b26242189d2be.png";